export default "__VITE_ASSET__C2ghVi6Z__"